'use strict';

module.exports = function () {
	$.ajax({
		type: 'POST',
		url: '/ajax/updateCart.php?data=' + $('#cart-line-to-ajax-update').val(),
		success: function(data){
			let newDataCart = $(data).find('.header-area-cart').html();
			$('.header-area-cart').html(newDataCart);
		}
	});



	$.ajax({
		type: 'POST',
		url: '/ajax/updateCart.php?data=' + $('#cart-line-to-ajax-update-mobile').val(),
		success: function(data){
			let newDataCart = $(data).html();
			$('.menu-buttons').html(newDataCart);
		}
	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/updateCart.js
 **/